export const emailValidator = (value: string): string | undefined => {
    if (!value) {
        return 'Email cannot be empty';
    }
}